import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=04df62f1&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04df62f1')) {
      api.createRecord('04df62f1', component.options)
    } else {
      api.reload('04df62f1', component.options)
    }
    module.hot.accept("./Pending.vue?vue&type=template&id=04df62f1&", function () {
      api.rerender('04df62f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/serviceStatus/Pending.vue"
export default component.exports